<div class="confirmation-dialog-container">
  <div class="confirmation-dialog-header">
    <div class="header-content">
      <div class="icon-container">
        <mat-icon [class]="'confirmation-icon icon-' + data.confirmColor">{{
          data.icon
        }}</mat-icon>
      </div>
      <h2 mat-dialog-title class="dialog-title">{{ data.title }}</h2>
    </div>
    <button
      mat-icon-button
      class="close-button"
      (click)="onCancel()"
      title="Close"
      aria-label="Close dialog"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div mat-dialog-content class="confirmation-dialog-content">
    <p class="confirmation-message">{{ data.message }}</p>
  </div>

  <div mat-dialog-actions class="confirmation-dialog-actions">
    <button mat-button type="button" (click)="onCancel()" class="cancel-button">
      {{ data.cancelText }}
    </button>
    <button
      mat-raised-button
      [color]="data.confirmColor"
      type="button"
      (click)="onConfirm()"
      class="confirm-button"
    >
      {{ data.confirmText }}
    </button>
  </div>
</div>
